import { render } from "./TransactionInquiryResultComponent.vue?vue&type=template&id=5f29e31c&scoped=true"
import script from "./TransactionInquiryResultComponent.vue?vue&type=script&lang=js"
export * from "./TransactionInquiryResultComponent.vue?vue&type=script&lang=js"

import "./TransactionInquiryResultComponent.vue?vue&type=style&index=0&id=5f29e31c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f29e31c"]])

export default __exports__